import { Toaster as Sonner, type ToasterProps } from 'sonner'

export const Toaster = (props: ToasterProps) => (
  <Sonner
    className="toaster group"
    position="top-center"
    // The front desk reads this while a person waits at the turnstile, so the
    // toast has to be legible from arm's length and gone before the next scan.
    toastOptions={{ duration: 3500 }}
    style={
      {
        '--normal-bg': 'var(--popover)',
        '--normal-text': 'var(--popover-foreground)',
        '--normal-border': 'var(--border)',
      } as React.CSSProperties
    }
    {...props}
  />
)
